import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  cursor: pointer;
  padding-left: 0px;
  width: 10px;

  &::before {
    content: '';
    width: 34px;
    height: 34px;
    position: absolute;
    transform: translateY(11px) translateX(0px);
    transform-origin: center;
  }

  &:after {
    content: '';
    display: block;
    width: 15px;
    height: 30px;
    position: absolute;
  }
`;
